import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledHeartFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3 4.102c0-1.242.515-2.299 1.318-3.018A15 15 0 0 0 11 1C3.5 1 1 6 1 11s2.5 10 10 10c2.96 0 5.142-.779 6.698-2.03l4.026 4.026 1.272-1.272-4.034-4.035C20.415 15.837 21 13.42 21 11c0-.768-.059-1.536-.186-2.286-1.029.732-2.132 1.356-3.214 2.005-1.406-.843-2.862-1.64-4.117-2.703C12.52 7.2 11.3 5.886 11.3 4.102m1.8 0c0-2.25 2.864-3.223 4.5-.887 1.636-2.336 4.5-1.25 4.5.887 0 1.875-2.625 3.393-4.5 4.518-1.875-1.125-4.5-2.643-4.5-4.518"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
MagnifierFilledHeartFilledSize24Glyph.displayName = 'MagnifierFilledHeartFilledSize24Glyph';
